export class ConfigSetting {
    name: string = "";
    value: any;
    description?: string;
    lastUpdate?: Date;
    version: number = 1;
}

